window.addEventListener('load', function() {
    eachOnce('.c-elections2', 'c-elections2', function(index, root) {
        var table = root.querySelector('.c-elections2-table');
        var inner = root.querySelector('.c-elections2-inner');
        var cell = table.querySelector('tbody td');
        var root_width;
        var table_width;
        var cell_width;
        var range = table_width - root_width;

        var calculate = function() {
            root_width = root.offsetWidth;
            table_width = table.offsetWidth;
            cell_width = cell.offsetWidth;
            range = table_width - root_width;
        };

        root.addEventListener('click', function() {
            if(event.target.matches('[data-nav]')){
                calculate();
                if (range > 0) {
                    var forward = event.target.matches('[data-next]');
                    var current = Math.floor(inner.scrollLeft / cell_width);
                    var next = (current + (forward ? 1 : -1)) * cell_width;
                    next = Math.max(Math.min(next,range),0);
                    inner.scrollLeft = next;
                };
            }
        });
    });
});

/*!
 * Scripts
 *
 */

function urlSafeString(s) {
    s = s || '';
    s = s.replace(/[^a-z0-9-]/gi, '_').toLowerCase();
    s = s.replace(/[_]+/g, '_');

    return s;
};


$(document).ready(function() {
"use strict";

    var urlSafeString = function (s) {
        return (s ? s.replace(/[^a-z0-9]/gi, '_').toLowerCase() : '_');
    };

	// chosen
	if ( $('.e16chosen-a select').length ) {
  	$('.e16chosen-a select').chosen().change(function() {
          var label = 'DropDown[' + $('body').attr("data-article") + ']|||||Main Area|Constituency List - ' + this.value + '||';
  		location.href=this.value;
  	});
  }

	// tabs

	$('.e16tabs-a').each(function(index, el) {
		var $root = $(this);

		$root.find('a[href^="#"]').on('click', function(event) {
      if (!$(this).parent().hasClass('leaflet-control')) {
        event.preventDefault();
        var $clicked = $(this);
        var $opened = $root.find('[data-tabgroup]').removeClass('is-active').filter('[data-tabgroup="'+ $clicked.data('tabtarget') +'"]').addClass('is-active');
        $clicked.closest('li').addClass('is-active').siblings('.is-active').removeClass('is-active');
        $opened.find('select').trigger("chosen:updated")
      }
		});
	});

	// large tabs

	$('.e16tabs-b').each(function(index, el) {
		var $root = $(this);

		$root.find('.tabs a[href^="#"]').on('click', function(event) {
			event.preventDefault();
			var $clicked = $(this);
			$($clicked.hrefId()).addClass('is-active').siblings('.tab.is-active').removeClass('is-active');
			$clicked.closest('li').addClass('is-active').siblings('.is-active').removeClass('is-active');
		});
	});

        // static pause-replay
        $('.e16dynamic-a #pause-replay').click(function() {
            if ($(this).text() == "Pause") {
                $('.e16dynamic-a .controls li.play').addClass('pause');
                $('.e16dynamic-a .controls li.pause').removeClass('play');
            } else {
                $('.e16dynamic-a .controls li.pause').addClass('play');
                $('.e16dynamic-a .controls li.play').removeClass('pause');
            }
	});

	// static table

	$('.e16static-a').each(function(index, el) {
		var $root = $(this);
		var $one = $root.find('.one');
                var $onewrap = $one.find('> .wrap');
		var $two = $one.clone().attr('class', 'two').insertAfter($one);
		$root.prepend('<p class="nav"><a href="#" class="p"></a> <a href="#" class="n"></a></p>')

		var current = 0;
		var visible = typeof static_cols == 'undefined' ? 7 : static_cols;
		var count = $one.find('tbody tr:first > td').size();

                //check how many count is visible and hide the navigation if less then the maximum count number
                if (visible >= count) {
                    $root.find('.nav').hide();
                }

		var max = count-visible;
//		var width = $one.find('tbody tr:first > td:first').width();
		var width = 96;
		var show = function(index){
			if(index < 0 || index > max) return;
			$onewrap.css('margin-left', '-'+index*width+'px');
			current = index;
		}

                //slide the wrapper to the end, so showing the last count
                $onewrap.css('margin-left', '-'+max*width+'px');
                //current is the last count, so we cannot slide forward just back
                current = max;

		$root.find('.nav a').on('click', function(event) {
                    event.preventDefault();
                    show($(this).is('.p') ? current-1 : current+1);
		});
	});

        // toggle teasers
        $('.e16teaser-a').click(function(event) {
            var data = 'close';
            var candidate = $(this).find('h3.hx').text().trim();
            if (!$(this).hasClass('is-active')) {
                var subUrl = urlSafeString($('body').attr("data-article")) + "/open-candidate-info/" + urlSafeString(candidate);
                // com.inmplc.tracking.trackVirtualPageView('virtual-pis/' + subUrl);

                data = 'open';
                $(this).addClass('is-active');
            } else {
                $(this).removeClass('is-active');
            }

            var label = 'ReadMore[' + $('body').attr("data-article") + ']|||||Main Area|Candidate List - ' + candidate + '||' + data;
        });

	$('<a href="#" class="toggler"></a>').on('click', function(event) {
            event.preventDefault();
	}).prependTo($('.e16teaser-a > .header'));

});
